import { throttle } from "lodash";
import { useEffect } from "react";

export const ResizableContent: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    // Function to calculate and send the height
    const updateHeight = () => {
      const height = document.getElementById("root")?.clientHeight;

      window.parent.postMessage({ type: "RESIZE_IFRAME", height }, "*");
    };

    // Create a throttled version of the updateHeight function
    const throttledUpdateHeight = throttle(updateHeight, 100); // Adjust throttle limit as needed

    // Initial height calculation and send
    updateHeight();

    // Use ResizeObserver to detect size changes
    const resizeObserver = new ResizeObserver(throttledUpdateHeight);
    resizeObserver.observe(document.documentElement);

    // Use MutationObserver to detect changes in DOM structure
    const mutationObserver = new MutationObserver(throttledUpdateHeight);
    mutationObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });

    // Optionally, handle resizing on window load or specific events
    window.addEventListener("load", updateHeight);

    return () => {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      window.removeEventListener("load", updateHeight);
    };
  }, []);

  return <div>{children}</div>;
};
